export const AUTHENTICATION_TOKEN_KEY = 'AUTHENTICATION_TOKEN_KEY';
export const AUTHENTICATED_USER_INFO = 'AUTHENTICATED_USER_INFO';
